import {Injectable} from '@angular/core';
import {DcpCheckoutPaymentService} from '@app/payment/services/dcp-checkout-payment.service';
import {DcpApiService, DcpGlobalMessageService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ActiveCartFacade} from '@spartacus/cart/base/root';
import {GlobalMessageType, TranslationService} from '@spartacus/core';
import {PaymentMethod, SetupIntent} from '@stripe/stripe-js';
import {Observable} from 'rxjs';
import {first, map, switchMap} from 'rxjs/operators';

interface RegisterCreditCardInDpaoResponse {
  dpaoSubscriptionId: string;
}

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DpaoService {

  constructor(
    private apiService: DcpApiService,
    private activeCartFacade: ActiveCartFacade,
    private dcpCheckoutPaymentService: DcpCheckoutPaymentService,
    private translationService: TranslationService,
    private dcpGlobalMessageService: DcpGlobalMessageService
  ) {
  }

  /**
   * returns dpaoSubscriptionId
   */
  registerCreditCard(setupIntent: SetupIntent): Observable<string> {
    return this.activeCartFacade.getActive().pipe(
      first(),
      switchMap(cart => {
        const {vendor, salesOrg} = this.dcpCheckoutPaymentService.getVendorSalesOrg(cart);
        const paymentMethodId = (setupIntent.payment_method as PaymentMethod).id;
        return this.apiService.callKyma<RegisterCreditCardInDpaoResponse>('pspIntegration', 'registerInDPAO', {},
          {
            body: {
              paymentMethodId,
              salesOrg,
              vendorId: vendor,
              currency: cart.totalPrice.currencyIso,
            }
          }, 'POST').pipe(map(response => response.dpaoSubscriptionId));
      })
    );
  }

  displayError(): void {
    this.translationService.translate('checkout.digitalNativeCheckout.paymentType.cc.dpaoRegisterCardError').pipe(
      first(), untilDestroyed(this)
    ).subscribe(message => {
      this.dcpGlobalMessageService.addMessage(
        {
          message,
          type: GlobalMessageType.MSG_TYPE_ERROR,
        },
        this.constructor.name, 'errorLogging'
      );
    });
  }

  hideError(): void {
    this.dcpGlobalMessageService.resetMessages();
  }
}
